
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.871","height":"33.878"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 711","fill":"#088dd1"}},[_c('path',{attrs:{"data-name":"Path 6978","d":"M18.884 11.554v-.7h-.01a7.464 7.464 0 00-6.413-7V.005h-2.05v3.849a7.464 7.464 0 00-6.413 7h-.01V22.016H.001v11.862h22.871V22.015h-3.987zm-7.773-7.777V.701h.65v3.076zm.325.7a6.76 6.76 0 016.737 6.376H4.698a6.76 6.76 0 016.737-6.376zm-6.748 7.077h13.5v10.462h-13.5zm8.388 21.624v-3.176a1.285 1.285 0 00-1.285-1.285h-.709a1.285 1.285 0 00-1.285 1.285v3.176h-9.1v-5.241h6.4l4.333-1.988 4.333 1.988h6.4v5.241zm9.1-10.462v4.521h-6.249l-4.486-2.058-4.486 2.058H.706v-4.521h21.47z"}}),_c('path',{attrs:{"data-name":"Rectangle 266","d":"M7.026 15.213h1.409v3.143H7.026z"}}),_c('path',{attrs:{"data-name":"Rectangle 267","d":"M10.731 15.213h1.409v3.143h-1.409z"}}),_c('path',{attrs:{"data-name":"Rectangle 268","d":"M14.435 15.213h1.409v3.143h-1.409z"}}),_c('path',{attrs:{"data-name":"Rectangle 269","d":"M14.435 29.538h1.075v2.397h-1.075z"}}),_c('path',{attrs:{"data-name":"Rectangle 270","d":"M17.261 29.538h1.075v2.397h-1.075z"}}),_c('path',{attrs:{"data-name":"Rectangle 271","d":"M20.086 29.538h1.075v2.397h-1.075z"}}),_c('path',{attrs:{"data-name":"Rectangle 272","d":"M1.729 29.538h1.075v2.397H1.729z"}}),_c('path',{attrs:{"data-name":"Rectangle 273","d":"M4.555 29.538H5.63v2.397H4.555z"}}),_c('path',{attrs:{"data-name":"Rectangle 274","d":"M7.38 29.538h1.075v2.397H7.38z"}})])])
          )
        }
      }
    